import { useTLang } from 'intl/intl';

export function useAuditableChipLang() {
  return {
    label: useTLang({ id: 'order.chip.isAuditable' }),
  };
}
